export default {
    cptDataForm: {
        dataText: '{"value":60,"total":100}', dataSource: 1, pollTime: 0
    },
    attribute: {
        border:{show:true,radius:2,color:'#00F0FF',lineType:'solid',width:1},
        icon:{url:'/imgPool/afd95e2ce8fb4a9aa6d903fcd6e4570b.svg',autoRotate:false, show: true},
        padding:{top:10,right:10,bottom:10,left:10},
        label:{totalLabel:'总数',valueLabel:'已使用',color:'#ddd',fontSize:13,fontFamily:''},
        value:{color:'#3c8fe3',fontSize:16,fontFamily:'',position:'progress'},
        progress:{color:['#f00','#ff0'],bgColor:'#12365b',size:112},
        cptTableData:[{"name":"指标","value":"","namekey":"value"},{"name":"总数量","value":"","namekey":"total"}]
    },
}
